import React, { useEffect, useState } from 'react'
import { Card } from '@radix-ui/themes'

import { useAuth } from '../hooks/useAuth'
import { UserProfileRole } from '../modules/users/types/UserProfile'

import { ButtonAction, ButtonMenuSet } from './Buttons'
import DocAnula from './DocAnula'

import { AppPath } from '@/enums/AppPath.ts'

const SubMenuSettlement: React.FC<{
  handleGoBackEdit: () => void
  handleAnular: (reason: string) => void
  esAnulada: boolean
}> = ({ handleGoBackEdit, handleAnular, esAnulada }) => {
  const [clickedIndex, setClickedIndex] = useState<number>(-1)
  const [motivo, setMotivo] = useState<string>('')
  const { hasRole } = useAuth()

  const canModify = hasRole(UserProfileRole.EditSettlements)
  const canVoid = hasRole(UserProfileRole.VoidSettlements)

  const handleMenuClick = (index: number) => {
    setClickedIndex(index)
  }

  const handleAnularClick = () => {
    if (motivo.trim()) {
      handleAnular(motivo)
    }
  }

  const handleMotivoChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setMotivo(e.target.value)
  }

  useEffect(() => {
    // Scroll to bottom when menu changes
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' })
  }, [clickedIndex])

  const modificarCaption = canModify ? 'Modificar' : ''
  const anularCaption = canVoid ? 'Anular' : ''

  const buttonCaptions = [modificarCaption, anularCaption]

  if (esAnulada) {
    return null
  }

  return (
    <Card mt="4">
      <ButtonMenuSet captions={buttonCaptions} clickedIndex={clickedIndex} handleButtonClick={handleMenuClick} />
      <div className="mt-4">
        {clickedIndex === 0 && (
          <>
            <div>
              Podrás modificar los datos de esta liquidación, excepto el cliente y el vehículo. Si deseas modificarlos,
              debes anular esta liquidación y crear otra.
            </div>
            <div className="flex justify-center mt-4">
              <ButtonAction label="Ir a modificar" handleButtonClick={handleGoBackEdit} />
            </div>
          </>
        )}
        {clickedIndex === 1 && (
          <DocAnula
            label="Motivo de anulación"
            header={'Al anular la liquidación esta ya no será legalmente válida.'}
            name="motivo"
            value={motivo}
            docType={AppPath.Settlements}
            handleInputChange={handleMotivoChange}
            handleButtonClick={handleAnularClick}
          />
        )}
      </div>
    </Card>
  )
}

export default SubMenuSettlement
